import { CONTROLLED_DATE_TIME_PICKER_TYPES } from "@elliemae/ds-controlled-form";
import { processFieldOptionsFromLookups } from "../services/schemaTools";
const GeneralLoanInfoVisibleFields = [
  {
    label: "Effective Date",
    component_id: "Effective Date",
    id: "4e60c809-e23f-4d63-97fd-934f1036312e",
    required: false,
    type: "string",
    ui: {
      col_size: 3,
      widget: "datepicker",
      type: CONTROLLED_DATE_TIME_PICKER_TYPES.DATE_TIME.FULL
    },
    visible: true,
    disabled: true,
    disable_check: {
      handler: "1f2f6425-fa45-407a-9f6e-dab82f658282"
    },
    encompass_ids: [
      {
        id: "relockRequest.effectiveDate",
        description: "Effective Date",
        modelPath: "relockRequest.effectiveDate"
      }
    ]
  },
  {
    label: "Loan Officer",
    component_id: "Loan Officer",
    ui: { col_size: 3, widget: "dropdown" },
    selectMultiple: false,
    visible: false,
    visible_check: {
      handler: "62af1e06-20c3-4904-ba36-166c5ba2daf1"
    },
    id: "f25c8e38-d069-4bbe-8180-485c747f5c25",
    type: "enum",
    encompass_ids: [
      {
        id: "eppsUserName",
        description: "Loan Officer",
        modelPath: "eppsUserName"
      }
    ],
    options: []
  },
  {
    label: "Lien Position",
    component_id: "Lien Position",
    ui: { col_size: 3, widget: "dropdown" },
    selectMultiple: false,
    visible: true,
    required: true,
    id: "0f46e11d-acc2-4b20-b2d4-aba14ebe6f15",
    type: "enum",
    encompass_ids: [
      {
        id: "loanInformation.lienPosition",
        description: "Lien Position",
        modelPath: "loanInformation.lienPosition"
      }
    ],
    options: []
  },
  {
    label: "Loan Purpose",
    component_id: "Loan Purpose",
    ui: { col_size: 3, widget: "dropdown" },
    selectMultiple: false,
    required: true,
    visible: true,
    id: "7e7dd2a6-7ec9-4518-bfa2-71379c63f056",
    type: "enum",
    encompass_ids: [
      {
        id: "loanInformation.loanPurpose",
        description: "Loan Purpose",
        modelPath: "loanInformation.loanPurpose"
      }
    ],
    options: []
  },
  {
    label: "Purchase Price/Property Value",
    component_id: "Purchase Price/Property Value",
    id: "38c6c123-fef9-48a8-81bf-c8cc91ff625f",
    encompass_ids: [
      {
        id: "property.value",
        description: "Purchase Price/Property Value",
        modelPath: "property.value"
      }
    ],
    type: "number",
    ui: {
      col_size: 3,
      widget: "currency"
    },
    visible: false,
    required: true,
    visible_check: {
      handler: "afd0dba5-5bdd-4405-967b-da2a51068583"
    }
  },
  {
    label: "Property Value",
    component_id: "Property Value",
    id: "339654f1-08a0-4f3c-ae85-529d7d2b892d",
    encompass_ids: [
      {
        id: "property.value",
        description: "Purchase Price/Property Value",
        modelPath: "property.value"
      }
    ],
    type: "number",
    ui: {
      col_size: 3,
      widget: "currency"
    },
    visible: true,
    required: true,
    visible_check: {
      handler: "afd0dba5-5bdd-4405-967b-da2a51068583"
    }
  },
  {
    label: "Loan Amount",
    component_id: "Loan Amount",
    id: "1132f407-1920-4b66-99de-312faafb89c9",
    encompass_ids: [
      {
        id: "loanInformation.firstMortgageAmount",
        description: "Loan Amount",
        modelPath: "loanInformation.firstMortgageAmount"
      }
    ],
    type: "number",
    ui: {
      col_size: 3,
      widget: "currency"
    },
    visible: true,
    visible_check: {
      handler: "ac5bf777-020a-45e2-9636-8bd4e7447a8f"
    },
    required: true
  },
  {
    label: "Loan Amount (Initial Draw)",
    component_id: "Loan Amount (Initial Draw)",
    id: "97251514-e679-4589-836d-98f9ab4f163b",
    encompass_ids: [
      {
        id: "loanInformation.firstMortgageAmount",
        description: "Loan Amount (Initial Draw)",
        modelPath: "loanInformation.firstMortgageAmount"
      }
    ],
    type: "number",
    ui: {
      col_size: 3,
      widget: "currency"
    },
    visible: false,
    visible_check: {
      handler: "322159db-fd06-4203-88cc-ba7dd14707bc"
    },
    required: true
  },
  {
    label: "1st Mortgage Balance",
    component_id: "1st Mortgage Balance",
    id: "588587d3-952c-4ed7-b760-066831c66061",
    encompass_ids: [
      {
        id: "loanInformation.firstMortgageAmount",
        description: "1st Mortgage Balance",
        modelPath: "loanInformation.firstMortgageAmount"
      }
    ],
    type: "number",
    ui: {
      col_size: 3,
      widget: "currency"
    },
    visible: false,
    visible_check: {
      handler: "305c1831-0004-4a2e-8cdb-6bf85c1a0029"
    },
    required: true
  },
  {
    label: "Other Closed End 2nd Mortgage",
    component_id: "Other Closed End 2nd Mortgage",
    id: "42f30a45-aff8-49a8-87f0-b28e73e7dc68",
    encompass_ids: [
      {
        id: "loanInformation.totSubClosedEndMort",
        description: "Other Closed End 2nd Mortgage",
        modelPath: "loanInformation.totSubClosedEndMort"
      }
    ],
    type: "number",
    ui: {
      col_size: 3,
      widget: "currency"
    },
    visible: true,
    visible_check: {
      handler: "eddabb96-3e46-429f-93e8-3d33e02e4639"
    }
  },
  {
    label: "Monthly Housing Payment",
    component_id: "Monthly Housing Payment",
    id: "dddbfff4-1bd1-426c-ae43-d25be094a8f1",
    encompass_ids: [
      {
        id: "loanInformation.otherPayment",
        description: "Monthly Housing Payment",
        modelPath: "loanInformation.otherPayment"
      }
    ],
    type: "number",
    ui: {
      col_size: 3,
      widget: "currency"
    },
    visible: true,
    required: true,
    visible_check: {
      handler: "eddabb96-3e46-429f-93e8-3d33e02e4639"
    }
  },
  {
    label: "Loan Amount/Initial Draw",
    component_id: "Loan Amount/Initial Draw",
    id: "ec856f68-1991-4240-be2d-6302cbebeeaf",
    encompass_ids: [
      {
        id: "loanInformation.secondMortgageAmount",
        description: "Loan Amount/Initial Draw",
        modelPath: "loanInformation.secondMortgageAmount"
      }
    ],
    type: "number",
    ui: {
      col_size: 3,
      widget: "currency"
    },
    required: true,
    visible: true,
    visible_check: {
      handler: "eddabb96-3e46-429f-93e8-3d33e02e4639"
    }
  },
  {
    label: "Other HELOC Draws",
    component_id: "Other HELOC Draws",
    id: "6a75ff49-9935-47d4-9149-e1c068cb6ecf",
    encompass_ids: [
      {
        id: "loanInformation.otherHELOCDraws",
        description: "Other HELOC Draws",
        modelPath: "loanInformation.otherHELOCDraws"
      }
    ],
    type: "number",
    ui: {
      col_size: 3,
      widget: "currency"
    },
    visible: true,
    visible_check: {
      handler: "eddabb96-3e46-429f-93e8-3d33e02e4639"
    },
    disabled: true
  },
  {
    label: "Max Loan Amount/Max Line",
    component_id: "Max Loan Amount/Max Line",
    id: "21aea877-8f9a-4be7-a3aa-1e7091e5db4d",
    encompass_ids: [
      {
        id: "loanInformation.loanAmountMaxLine",
        description: "Max Loan Amount/Max Line",
        modelPath: "loanInformation.loanAmountMaxLine"
      }
    ],
    type: "number",
    ui: {
      col_size: 3,
      widget: "currency"
    },
    visible: false,
    visible_check: {
      handler: "213beec3-7caf-45be-9cec-67359ee890b3"
    }
  },
  {
    label: "Government Fees",
    component_id: "Government Fees",
    id: "33bdb99e-4dfc-4767-9994-362cec731353",
    type: "field_group",
    visible: true,
    fields: [
      {
        label: "Factor",
        component_id: "Factor",
        id: "ddc0e03c-4405-47ad-a02a-532a560928fd",
        encompass_ids: [
          {
            id: "loanInformation.govtFeeFactor",
            description: "Govt Fee Factor",
            modelPath: "loanInformation.govtFeeFactor"
          }
        ],
        type: "number",
        ui: {
          col_size: 3,
          widget: "percent"
        }
      },
      {
        label: "Amount",
        component_id: "Amount",
        id: "cadc1f71-6855-4b04-a306-fab994c3489f",
        encompass_ids: [
          {
            id: "loanInformation.feeAmount",
            description: "Fee Amount",
            modelPath: "loanInformation.feeAmount"
          }
        ],
        type: "number",
        ui: {
          col_size: 3,
          widget: "currency"
        }
      },
      {
        label: "Financed Amount",
        component_id: "Financed Amount",
        id: "2f61ca2b-26e6-4548-a30d-67208f3d2128",
        encompass_ids: [
          {
            id: "loanInformation.feeAmountFinanced",
            description: "Fee Amount Financed",
            modelPath: "loanInformation.feeAmountFinanced"
          }
        ],
        type: "number",
        ui: {
          col_size: 3,
          widget: "currency"
        }
      },
      {
        label: "Paid in Cash",
        component_id: "Paid in Cash",
        id: "0216c5ef-156a-4dad-8012-1b63a384e592",
        encompass_ids: [
          {
            id: "loanInformation.feeAmountPaidinCash",
            description: "Fee Amount Paid In Cash",
            modelPath: "loanInformation.feeAmountPaidinCash"
          }
        ],
        type: "number",
        ui: {
          col_size: 3,
          widget: "currency"
        }
      },
      {
        label: "VA exempt",
        component_id: "VA exempt",
        id: "3039d8c7-868a-4cec-8bff-59998faaf59d",
        encompass_ids: [
          {
            id: "loanInformation.vaFundingFeeExempted",
            description: "VA Loan Summ Discount Info",
            modelPath: "loanInformation.vaFundingFeeExempted"
          }
        ],
        type: "boolean",
        ui: { col_size: 3, widget: "checkbox" }
      },
      {
        label: "1st Time use of VA loan",
        component_id: "1st Time use of VA loan",
        id: "387f069e-9c3b-49bf-81de-dd157d2799f7",
        encompass_ids: [
          {
            id: "loanInformation.vaFirstTimeUse",
            description: "VA Loan Summ 1st Time Use VA Loan Program",
            modelPath: "loanInformation.vaFirstTimeUse"
          }
        ],
        type: "boolean",
        ui: { col_size: 3, widget: "checkbox" }
      }
    ]
  },
  {
    label: "Other HELOC Lines",
    component_id: "Other HELOC Lines",
    id: "0a8ccab1-48bd-48f1-9c8d-f650a9735131",
    encompass_ids: [
      {
        id: "loanInformation.otherHELOCLines",
        description: "Other HELOC Lines",
        modelPath: "loanInformation.otherHELOCLines"
      }
    ],
    type: "number",
    ui: {
      col_size: 3,
      widget: "currency"
    },
    disabled: true,
    visible: true,
    visible_check: {
      handler: "eddabb96-3e46-429f-93e8-3d33e02e4639"
    }
  },
  {
    label: "PMI, MIP Financed",
    component_id: "PMI, MIP Financed",
    id: "98aa0ee9-13f6-471d-998c-691f9d3600de",
    encompass_ids: [
      {
        id: "loanInformation.financedAmount",
        description: "PMI, MIP Financed",
        modelPath: "loanInformation.financedAmount"
      }
    ],
    type: "number",
    ui: {
      col_size: 3,
      widget: "currency"
    },
    visible: true,
    visible_check: {
      handler: "dc1c8abd-0d8e-4d6f-ba01-36e484bccc05"
    }
  },
  {
    label: "Total Loan Amount",
    component_id: "Total Loan Amount",
    id: "dff1b589-a9a3-475a-9b65-ba0d99119ae5",
    encompass_ids: [
      {
        id: "loanInformation.totalMortgageAmount",
        description: "Total Loan Amount",
        modelPath: "loanInformation.totalMortgageAmount"
      }
    ],
    type: "number",
    ui: {
      col_size: 3,
      widget: "currency"
    },
    visible: false,
    disabled: true,
    visible_check: {
      handler: "eddabb96-3e46-429f-93e8-3d33e02e4639"
    }
  },
  {
    type: "number",
    label: "Cash Out",
    component_id: "Cash Out",
    id: "7c272b62-b841-46d0-9d98-a1a3825ca121",
    ui: {
      col_size: 2,
      widget: "currency"
    },
    visible: true,
    required: true,
    encompass_ids: [
      {
        id: "loanInformation.cashOut",
        description: "Cash Out",
        modelPath: "loanInformation.cashOut"
      }
    ],
    visible_check: {
      handler: "d72d3321-a47a-4b43-be78-54a8a7e0ced2"
    }
  }
];
const GeneralLoanInfoDetailedFields = [
  {
    component_id: "2nd Mortgage Balance",
    id: "45cb7c7e-3091-41ea-84d6-c204de709325",
    label: "2nd Mortgage Balance",
    encompass_ids: [
      {
        id: "loanInformation.secondMortgageAmount",
        description: "2nd Mortgage Balance",
        modelPath: "loanInformation.secondMortgageAmount"
      }
    ],
    type: "number",
    visible: false,
    visible_check: {
      handler: "eddabb96-3e46-429f-93e8-3d33e02e4639"
    },
    ui: { col_size: 3, widget: "currency" }
  },
  {
    component_id: "2nd Mortgage Payment",
    id: "5d1f7712-6ef2-45b7-9d98-c21cd904b235",
    label: "2nd Mortgage Payment",
    encompass_ids: [
      {
        id: "loanInformation.otherPayment",
        description: "2nd Mortgage Payment",
        modelPath: "loanInformation.otherPayment"
      }
    ],
    type: "number",
    visible: false,
    visible_check: {
      handler: "eddabb96-3e46-429f-93e8-3d33e02e4639"
    },
    ui: { col_size: 3, widget: "currency" }
  },
  {
    label: "Commitment Type",
    component_id: "Commitment Type",
    ui: { col_size: 3, widget: "dropdown" },
    selectMultiple: false,
    required: true,
    visible: true,
    visible_check: {
      handler: "b8e31c77-8a8f-4f43-b748-ab4d3404fa3d"
    },
    id: "46308681-4b5c-42b7-97c3-36c3c49f71c7",
    type: "enum",
    encompass_ids: [
      {
        id: "loanInformation.commitmentType",
        description: "Commitment Type",
        modelPath: "loanInformation.commitmentType"
      }
    ],
    options: []
  },
  {
    label: "Delivery Type",
    component_id: "Delivery Type",
    ui: { col_size: 3, widget: "dropdown" },
    selectMultiple: false,
    required: true,
    visible: true,
    disabled: true,
    visible_check: {
      handler: "b8e31c77-8a8f-4f43-b748-ab4d3404fa3d"
    },
    id: "6b9e4e2a-689d-416f-a78d-b16ae1f14798",
    type: "enum",
    encompass_ids: [
      {
        id: "deliveryType",
        description: "Delivery Type",
        modelPath: "deliveryType"
      }
    ],
    options: [
      {
        id: "Individual Best Efforts",
        value: "2",
        text: "Individual Best Efforts",
        visible: true
      },
      {
        id: "Individual Mandatory",
        value: "1",
        text: "Individual Mandatory",
        visible: true
      }
    ]
  },
  {
    type: "number",
    label: "LTV",
    component_id: "LTV",
    id: "9b474910-43a1-4f85-9fca-90aec89414a8",
    ui: {
      col_size: 1,
      widget: "percent"
    },
    visible: true,
    disable_check: {
      handler: "305c1831-0004-4a2e-8cdb-6bf85c1a0029"
    },
    encompass_ids: [
      {
        id: "loanInformation.ltv",
        description: "LTV",
        modelPath: "loanInformation.ltv"
      }
    ]
  },
  {
    type: "number",
    label: "CLTV",
    component_id: "CLTV",
    id: "a2c47a8d-4cca-4764-9d14-bba23151b079",
    ui: {
      col_size: 1,
      widget: "percent"
    },
    visible: true,
    disabled: true,
    encompass_ids: [
      {
        id: "loanInformation.cltv",
        description: "CLTV",
        modelPath: "loanInformation.cltv"
      }
    ]
  },
  {
    type: "number",
    label: "HCLTV",
    component_id: "HCLTV",
    id: "a5701c22-034e-4dfe-8c7a-3ab3778bc057",
    ui: {
      col_size: 1,
      widget: "percent"
    },
    disabled: true,
    encompass_ids: [
      {
        id: "loanInformation.hcltv",
        description: "HCLTV",
        modelPath: "loanInformation.hcltv"
      }
    ],
    visible: false,
    visible_check: {
      handler: "955b111f-f1c5-44de-8635-6a5fa6019ac9"
    }
  },
  {
    type: "boolean",
    label: "Community/Affordable Second",
    component_id: "Community/Affordable Second",
    id: "9867fbec-90ad-4aa5-9e28-1163970a39c9",
    ui: { col_size: 3, widget: "checkbox" },
    visible: true,
    encompass_ids: [
      {
        id: "loanInformation.communityAffordableSecond",
        description: "Community/Affordable Second",
        modelPath: "loanInformation.communityAffordableSecond"
      }
    ]
  },
  {
    type: "boolean",
    label: "No Closing Costs",
    component_id: "No Closing Costs",
    id: "e759e74a-7f2c-4f69-80ab-37b75d0203a8",
    ui: { col_size: 3, widget: "checkbox" },
    visible: true,
    encompass_ids: [
      {
        id: "loanInformation.noClosingCost",
        description: "No Closing Costs",
        modelPath: "loanInformation.noClosingCost"
      }
    ]
  },
  {
    type: "boolean",
    label: "Lender Fee Waiver",
    component_id: "Lender Fee Waiver",
    id: "40892cdc-f168-4010-a867-0da91454e7e7",
    visible: true,
    ui: { col_size: 3, widget: "checkbox" },
    encompass_ids: [
      {
        id: "loanInformation.lenderFeeWaiver",
        description: "Lender Fee Waiver",
        modelPath: "loanInformation.lenderFeeWaiver"
      }
    ]
  },
  {
    type: "boolean",
    label: "Closing Costs are included in the Loan Amount",
    component_id: "Closing Costs are included in the Loan Amount",
    id: "67768f38-184e-4551-b240-c0df5a396488",
    visible: false,
    visible_check: {
      handler: "49cf07c3-2f06-41a1-8c5e-64580fa0730b"
    },
    ui: { col_size: 3, widget: "checkbox" },
    encompass_ids: [
      {
        id: "loanInformation.includeClosingCost",
        description: "Closing Costs are included in the Loan Amount",
        modelPath: "loanInformation.includeClosingCost"
      }
    ]
  }
];
const ProductInfoVisibleFields = [
  {
    label: "Loan Terms",
    component_id: "Loan Terms",
    helptext: "Select one or more loan terms",
    id: "cb3f524e-8051-4a14-a0a2-e488c07ced41",
    required: false,
    type: "enum",
    ui: { col_size: 4, widget: "dropdown" },
    visible: true,
    selectMultiple: true,
    encompass_ids: [
      {
        id: "productType",
        description: "Loan Terms",
        modelPath: "productType"
      }
    ],
    options: []
  },
  {
    label: "Custom Term",
    component_id: "Custom Term",
    id: "8361574e-6f1c-4c4b-9b20-debd419c38df",
    required: false,
    type: "number",
    ui: { col_size: 4 },
    visible: true,
    encompass_ids: [
      {
        id: "loanInformation.term",
        description: "Custom Term",
        modelPath: "loanInformation.term"
      }
    ]
  },
  {
    label: "Standard Products",
    component_id: "Standard Products",
    helptext: "Select one or more standard products",
    id: "fa98ef18-bf10-40b2-8334-ca4627e718f5",
    required: false,
    type: "enum",
    ui: { col_size: 4, widget: "dropdown" },
    visible: true,
    selectMultiple: true,
    encompass_ids: [
      {
        id: "standardProducts",
        description: "Standard Products",
        modelPath: "standardProducts"
      }
    ],
    options: []
  },
  {
    label: "Target Value",
    component_id: "Target Value",
    id: "bccf727d-4b74-44e4-938c-47a7dc54ac2f",
    required: true,
    type: "enum",
    ui: { col_size: 4, widget: "dropdown" },
    visible: true,
    encompass_ids: [
      {
        id: "loanInformation.targetLabel",
        description: "Target Value",
        modelPath: "loanInformation.targetLabel"
      }
    ],
    selectMultiple: false,
    options: [
      { id: "Rate", value: "Rate", text: "Rate", visible: true },
      { id: "Price", value: "Price", text: "Price", visible: true }
    ]
  },
  {
    label: "Target Price",
    component_id: "Target Price",
    id: "1e8f263a-31ea-45ba-aa8c-926971d77c38",
    required: true,
    type: "number",
    ui: { col_size: 4 },
    visible: false,
    visible_check: {
      handler: "4a43e7d4-a2a0-4e51-a01b-2f5d943b60a0"
    },
    encompass_ids: [
      {
        id: "loanInformation.target",
        description: "Target Price",
        modelPath: "loanInformation.target"
      }
    ]
  },
  {
    label: "Target Rate",
    component_id: "Target Rate",
    id: "17bd0af2-bbd2-453b-a18b-7faaec9d463f",
    required: true,
    type: "number",
    ui: { col_size: 4, widget: "percent" },
    visible: false,
    visible_check: {
      handler: "db74b73a-2117-43db-9352-ef915287f987"
    },
    encompass_ids: [
      {
        id: "loanInformation.target",
        description: "Target Rate",
        modelPath: "loanInformation.target"
      }
    ]
  },
  {
    label: "FHA Case Number Date",
    component_id: "FHA Case Number Date",
    id: "f2bb27e2-67b0-4812-a8a6-c0bf27e4df47",
    required: false,
    type: "string",
    ui: {
      col_size: 3,
      widget: "datepicker",
      type: CONTROLLED_DATE_TIME_PICKER_TYPES.DATE.FULL
    },
    visible: true,
    encompass_ids: [
      {
        id: "loanInformation.fhaCaseNumberDate",
        description: "FHA Case Number Date",
        modelPath: "loanInformation.fhaCaseNumberDate"
      }
    ]
  },
  {
    label: "Special Products",
    component_id: "Special Products",
    id: "3a5f2d3f-91b9-4d34-9bdc-ee80081a66fa",
    required: false,
    type: "enum",
    ui: { col_size: 4, widget: "dropdown" },
    selectMultiple: true,
    visible: true,
    encompass_ids: [
      {
        id: "specialProducts",
        description: "Special Products",
        modelPath: "specialProducts"
      }
    ],
    options: []
  },
  {
    label: "UW Methods",
    component_id: "UW Methods",
    id: "2109f1b6-693b-44ea-82db-0dbc59a17cae",
    required: false,
    type: "enum",
    ui: {
      col_size: 4,
      widget: "dropdown"
    },
    selectMultiple: false,
    visible: true,
    encompass_ids: [
      {
        id: "loanInformation.underwritingMethodID",
        description: "Underwriting Risk Assess Type",
        modelPath: "loanInformation.underwritingMethodID"
      }
    ],
    options: []
  }
];
const ProductInfoDetailedFields = [
  {
    label: "Product Options",
    component_id: "Product Options",
    id: "7c327485-f6dd-4aa5-a9fe-a4b85790cf4f",
    required: false,
    type: "enum",
    ui: { col_size: 4, widget: "dropdown" },
    visible: true,
    selectMultiple: true,
    encompass_ids: [
      {
        id: "productOptions",
        description: "Product Options",
        modelPath: "productOptions"
      }
    ],
    options: []
  },
  {
    label: "Pre-payment Penalty",
    component_id: "Pre-payment Penalty",
    id: "9f417416-9645-423c-9dd7-22a9b9544df8",
    type: "enum",
    ui: { col_size: 4, widget: "dropdown" },
    visible: true,
    encompass_ids: [
      {
        id: "loanInformation.prepaymentPenaltyTerm",
        description: "Pre-payment Penalty",
        modelPath: "loanInformation.prepaymentPenaltyTerm"
      }
    ],
    selectMultiple: false,
    options: []
  },
  {
    label: "Compensation Type",
    component_id: "Compensation Type",
    id: "198c9ec8-0f44-41ce-ab3e-8a4c7b01be20",
    type: "enum",
    ui: { col_size: 4, widget: "dropdown" },
    visible: true,
    encompass_ids: [
      {
        id: "compensation.model",
        description: "Compensation Type",
        modelPath: "compensation.model"
      }
    ],
    selectMultiple: false,
    options: [
      {
        id: "Lender Paid",
        // model is 2
        value: "2",
        text: "Lender Paid",
        visible: true
      },
      {
        id: "Borrower Paid",
        // model is 1
        value: "1",
        text: "Borrower Paid",
        visible: true
      }
    ]
  },
  {
    label: "Temporary Buydown Type",
    component_id: "Temporary Buydown Type",
    helptext: "This must be updated in your loan origination system and resubmitted to ICE PPE",
    id: "d9fcd334-b39c-4ead-a745-88f621f77ca4",
    required: false,
    disabled: true,
    type: "enum",
    ui: { col_size: 4, widget: "dropdown" },
    visible: true,
    encompass_ids: [
      {
        id: "buydownType",
        description: "Temporary Buydown Type",
        modelPath: "buydownType"
      }
    ],
    selectMultiple: false,
    options: []
  },
  {
    label: "Temporary Buydown Contributor",
    component_id: "Temporary Buydown Contributor",
    id: "0d293499-d65b-459d-9e7c-6ddda37b9053",
    required: false,
    type: "enum",
    ui: { col_size: 4, widget: "dropdown" },
    visible: true,
    visible_check: {
      handler: "37de09f3-d2b4-42f8-bb50-70ee907b870a"
    },
    encompass_ids: [
      {
        id: "buydownContributor",
        description: "Temporary Buydown Contributor",
        modelPath: "buydownContributor"
      }
    ],
    selectMultiple: false,
    options: []
  }
];
const FinanceInfoVisibleFields = [
  {
    label: "Employment",
    component_id: "Employment",
    id: "107ee0fe-ef21-4ba4-a52a-59793f7fcef4",
    required: true,
    type: "enum",
    ui: { col_size: 4, widget: "dropdown" },
    visible: true,
    encompass_ids: [
      {
        id: "employment",
        description: "Employment",
        modelPath: "borrowerFinancialHistory.docTypeEmployment"
      }
    ],
    options: [
      {
        id: "Employed or Retired (can Verify)",
        value: "1",
        text: "Employed or Retired (can Verify)",
        visible: true
      },
      {
        id: "Self Employed (can Verify)",
        value: "2",
        text: "Self Employed (can Verify)",
        visible: true
      },
      {
        id: "Will Not Verify or Unemployed",
        value: "0",
        text: "Will Not Verify or Unemployed",
        visible: true
      }
    ]
  },
  {
    label: "Assets",
    component_id: "Assets",
    id: "5ce9c244-8cb3-45fa-98a1-a7bae86dd6e0",
    required: true,
    type: "enum",
    ui: { col_size: 4, widget: "dropdown" },
    visible: true,
    encompass_ids: [
      {
        id: "asset",
        description: "Assets",
        modelPath: "borrowerFinancialHistory.docTypeAsset"
      }
    ],
    options: [
      {
        id: "Full Assets",
        value: "100",
        text: "Full Assets",
        visible: true
      },
      {
        id: "Stated Assets",
        value: "50",
        text: "Stated Assets",
        visible: true
      },
      {
        id: "No Assets",
        value: "0",
        text: "No Assets",
        visible: true
      }
    ]
  },
  {
    label: "Income",
    component_id: "Income",
    id: "9552759a-2a01-4057-9e3f-58461349d1ff",
    required: true,
    type: "enum",
    ui: { col_size: 4, widget: "dropdown" },
    visible: true,
    encompass_ids: [
      {
        id: "income",
        description: "Income",
        modelPath: "borrowerFinancialHistory.docTypeIncome"
      }
    ],
    options: [
      {
        id: "Full Income",
        value: "100",
        text: "Full Income",
        visible: true
      },
      {
        id: "Alternative Income",
        value: "70",
        text: "Alternative Income",
        visible: true
      },
      {
        id: "Lite Income",
        value: "60",
        text: "Lite Income",
        visible: true
      },
      {
        id: "Stated Income",
        value: "50",
        text: "Stated Income",
        visible: true
      },
      {
        id: "No Income",
        value: "0",
        text: "No Income",
        visible: true
      }
    ]
  },
  {
    label: "DSCR",
    component_id: "DSCR",
    id: "d29d8fe1-74f3-4896-94a9-0a965427e9af",
    required: false,
    ui: {
      col_size: 4
    },
    visible: false,
    disabled: false,
    encompass_ids: [
      {
        id: "borrowerFinancialHistory.dscr",
        description: "DSCR",
        modelPath: "borrowerFinancialHistory.dscr"
      }
    ],
    visible_check: {
      handler: "829c15f3-68f2-4161-b44a-7361ec9d02bc"
    }
  },
  {
    label: "Non-QM Doc Level",
    component_id: "Non-QM Doc Level",
    id: "9c7bab92-2ec9-420a-9de2-d7ab576013ba",
    required: true,
    type: "enum",
    ui: { col_size: 4, widget: "dropdown" },
    visible: false,
    visible_check: {
      handler: "01fd7f37-f673-4de8-85fc-25de2d0855fc"
    },
    encompass_ids: [
      {
        id: "borrowerFinancialHistory.nonQMDocLevel",
        description: "Non-QM Doc Level",
        modelPath: "borrowerFinancialHistory.nonQMDocLevel"
      }
    ],
    options: []
  },
  {
    label: "Representative Credit Score",
    component_id: "Representative Credit Score",
    id: "9ab17071-54f9-4b48-9c71-bd3817bad26a",
    required: false,
    type: "number",
    ui: { col_size: 4, widget: "creditScore", show_label: true },
    show_label: true,
    visible: true,
    encompass_ids: [
      {
        id: "borrowers[0].borrowerFinanancial.creditScore",
        description: "Representative Credit Score",
        modelPath: "borrowers[0].borrowerFinanancial.creditScore"
      }
    ]
  },
  {
    label: "Avg. Repr Credit Score",
    component_id: "Avg. Repr Credit Score",
    id: "5e29a0c8-bdfa-4aff-a353-666d9349f1b4",
    required: false,
    type: "number",
    ui: { col_size: 4, widget: "creditScore", show_label: true },
    visible: true,
    disabled: true,
    encompass_ids: [
      {
        id: "loanInformation.averageRepresentativeCreditScore",
        description: "Avg. Repr Credit Score",
        modelPath: "loanInformation.averageRepresentativeCreditScore"
      }
    ]
  },
  {
    label: "No Credit Score",
    component_id: "No Credit Score",
    id: "d1c44ee2-6594-41bd-9e1e-90bdf2618081",
    type: "boolean",
    ui: { col_size: 4, widget: "checkbox" },
    visible: true,
    encompass_ids: [
      {
        id: "borrowerFinancialHistory.noCreditScores",
        description: "No Credit Score",
        modelPath: "borrowerFinancialHistory.noCreditScores"
      }
    ]
  },
  {
    label: "First Time Home Buyer",
    component_id: "First Time Home Buyer",
    id: "b99273b8-8aa9-485a-8601-24b486850568",
    type: "boolean",
    ui: { col_size: 4, widget: "checkbox" },
    visible: true,
    encompass_ids: [
      {
        id: "borrowerFinancialHistory.firstTimeHomeBuyers",
        description: "First Time Home Buyer",
        modelPath: "borrowerFinancialHistory.firstTimeHomeBuyers"
      }
    ]
  },
  {
    label: "Borrower can demonstrate 12-month mortgage/rental history",
    component_id: "Borrower can demonstrate 12-month mortgage/rental history",
    id: "87207af7-cd4e-4f99-9f55-a484b7414d26",
    type: "boolean",
    ui: { col_size: 4, widget: "checkbox" },
    visible: true,
    encompass_ids: [
      {
        id: "borrowerFinancialHistory.demonstrateHousingPaymentHistory",
        description: "Borrower can demonstrate 12-month mortgage/rental history",
        modelPath: "borrowerFinancialHistory.demonstrateHousingPaymentHistory"
      }
    ]
  }
];
const FinanceInfoDetailedFields = [
  {
    label: "Borrower Assets, Debt, and Income",
    component_id: "Borrower Details",
    id: "418fd10e-a116-414f-b9d6-821ca3ca2bf7",
    type: "field_group",
    visible: true,
    ui: {},
    fields: [
      {
        label: "Borrower First Name",
        component_id: "Borrower First Name",
        id: "214ea428-f7b5-45b7-9883-f86f074a038a",
        type: "string",
        visible: true,
        ui: { col_size: 5 },
        encompass_ids: [
          {
            id: "borrowers[0].firstName",
            description: "Borrower First Name",
            modelPath: "borrowers[0].firstName"
          }
        ]
      },
      {
        label: "Borrower Last Name",
        component_id: "Borrower Last Name",
        id: "603e7966-b95f-4d16-812e-08c2dd81d14d",
        type: "string",
        visible: true,
        ui: { col_size: 5 },
        encompass_ids: [
          {
            id: "borrowers[0].lastName",
            description: "Borrower Last Name",
            modelPath: "borrowers[0].lastName"
          }
        ]
      },
      {
        label: "Citizenship",
        component_id: "Citizenship",
        id: "c5e10413-a72c-4e69-9405-163f703abb35",
        type: "enum",
        visible: true,
        ui: { col_size: 5, widget: "dropdown" },
        encompass_ids: [
          {
            id: "borrowers[0].citizenship",
            description: "Citizenship",
            modelPath: "borrowers[0].citizenship"
          }
        ],
        options: []
      },
      {
        label: "Liquid Assets",
        component_id: "Liquid Assets",
        id: "586aee12-9ed5-4127-993e-435465a0bfe2",
        type: "number",
        visible: true,
        ui: { col_size: 5, widget: "currency" },
        encompass_ids: [
          {
            id: "borrowers[0].borrowerFinanancial.liquidAsset",
            description: "Liquid Assets",
            modelPath: "borrowers[0].borrowerFinanancial.liquidAsset"
          }
        ]
      },
      {
        label: "Retirement Assets",
        component_id: "Retirement Assets",
        id: "c7c24225-2bf3-4499-9684-8b25f6225087",
        type: "number",
        visible: true,
        ui: { col_size: 5, widget: "currency" },
        encompass_ids: [
          {
            id: "borrowers[0].borrowerFinanancial.retirementAsset",
            description: "Retirement Assets",
            modelPath: "borrowers[0].borrowerFinanancial.retirementAsset"
          }
        ]
      },
      {
        label: "Annual Income",
        component_id: "Annual Income",
        id: "5ce904aa-c2e4-446f-a373-0f4eee9d6f1a",
        type: "number",
        visible: true,
        ui: { col_size: 5, widget: "currency" },
        encompass_ids: [
          {
            id: "borrowers[0].borrowerFinanancial.income",
            description: "Annual Income",
            modelPath: "borrowers[0].borrowerFinanancial.income"
          }
        ]
      },
      {
        label: "Monthly Debt",
        component_id: "Monthly Debt",
        id: "3c3e375b-7ae7-44dd-8258-0e494fbdaed4",
        type: "number",
        visible: true,
        ui: { col_size: 5, widget: "currency" },
        encompass_ids: [
          {
            id: "borrowers[0].borrowerFinanancial.monthlyDebt",
            description: "Monthly Debt",
            modelPath: "borrowers[0].borrowerFinanancial.monthlyDebt"
          }
        ]
      }
    ]
  },
  {
    label: "Mortgage Delinquency",
    component_id: "Mortgage Delinquency",
    id: "8b8b6888-69a4-458f-887c-b009352bb131",
    type: "field_group",
    ui: {},
    visible: true,
    fields: [
      {
        label: "30 Day Delinquencies in Last 12 Months",
        component_id: "30 Day Delinquencies in Last 12 Months",
        id: "7775d2e3-97e7-4646-aaaa-d8fc2f09c7b1",
        type: "number",
        visible: true,
        ui: { col_size: 4 },
        helptext: "Please enter the number of 30-day Mortgage Delinquencies in the last 12 months (12 max).",
        encompass_ids: [
          {
            id: "borrowerFinancialHistory.30DaysMortgageLatestin12Months",
            description: "Mortgage Delinquency",
            modelPath: "borrowerFinancialHistory.30DaysMortgageLatestin12Months"
          }
        ]
      },
      {
        label: "60 Day Delinquencies in Last 12 Months",
        component_id: "60 Day Delinquencies in Last 12 Months",
        id: "13c147f3-1a47-4be8-b4e3-66f18113c785",
        type: "number",
        visible: true,
        ui: { col_size: 4 },
        helptext: "Please enter the number of 60-day Mortgage Delinquencies in the last 12 months (12 max).",
        encompass_ids: [
          {
            id: "borrowerFinancialHistory.60DaysMortgageLatestin12Months",
            description: "60 Day Delinquencies in Last 12 Months",
            modelPath: "borrowerFinancialHistory.60DaysMortgageLatestin12Months"
          }
        ]
      },
      {
        label: "90 Day Delinquencies in Last 12 Months",
        component_id: "90 Day Delinquencies in Last 12 Months",
        id: "d2e09d4c-1ff6-4353-8c96-f2139510cca5",
        type: "number",
        visible: true,
        ui: { col_size: 4 },
        helptext: "Please enter the number of 90-day Mortgage Delinquencies in the last 12 months (12 max).",
        encompass_ids: [
          {
            id: "borrowerFinancialHistory.90DaysMortgageLatestin12Months",
            description: "90 Day Delinquencies in Last 12 Months",
            modelPath: "borrowerFinancialHistory.90DaysMortgageLatestin12Months"
          }
        ]
      },
      {
        label: "30 Day Delinquencies in Last 13-24 Months",
        component_id: "30 Day Delinquencies in Last  13-24 Months",
        id: "04be4604-1dc7-4065-b3b8-6048de8d9eb6",
        type: "number",
        visible: true,
        ui: { col_size: 4 },
        helptext: "Please enter the number of 30-day Mortgage Delinquencies in the prior 13-24 months (12 max).",
        encompass_ids: [
          {
            id: "borrowerFinancialHistory.30DaysMortgageLatestin24Months",
            description: "30 Day Delinquencies in Last 13-24 Months",
            modelPath: "borrowerFinancialHistory.30DaysMortgageLatestin24Months"
          }
        ]
      },
      {
        label: "60 Day Delinquencies in Last  13-24 Months",
        component_id: "60 Day Delinquencies in Last  13-24 Months",
        id: "2e1fa7aa-82f7-4895-bda8-e9926e9b97a9",
        type: "number",
        visible: true,
        ui: { col_size: 4 },
        helptext: "Please enter the number of 60-day Mortgage Delinquencies in the prior 13-24 months (12 max).",
        encompass_ids: [
          {
            id: "borrowerFinancialHistory.60DaysMortgageLatestin24Months",
            description: "60 Day Delinquencies in Last  13-24 Months",
            modelPath: "borrowerFinancialHistory.60DaysMortgageLatestin24Months"
          }
        ]
      },
      {
        label: "90 Day Delinquencies in Last  13-24 Months",
        component_id: "90 Day Delinquencies in Last  13-24 Months",
        id: "1a48f174-b9a3-4716-9434-7e9de7f18c40",
        type: "number",
        visible: true,
        ui: { col_size: 4 },
        helptext: "Please enter the number of 90-day Mortgage Delinquencies in the prior 13-24 months (12 max).",
        encompass_ids: [
          {
            id: "borrowerFinancialHistory.90DaysMortgageLatestin24Months",
            description: "90 Day Delinquencies in Last  13-24 Months",
            modelPath: "borrowerFinancialHistory.90DaysMortgageLatestin24Months"
          }
        ]
      }
    ]
  },
  {
    label: "Default and Bankruptcy",
    component_id: "Default and Bankruptcy",
    id: "83590b14-4b31-4fde-938a-e19d3afd4686",
    type: "field_group",
    visible: true,
    ui: {},
    fields: [
      {
        label: "Notice of Default (NOD)",
        component_id: "Notice of Default (NOD)",
        id: "dabae052-684f-4ef5-94b5-746b32f2ce84",
        type: "enum",
        ui: { col_size: 3, widget: "dropdown" },
        visible: true,
        encompass_ids: [
          {
            id: "borrowerFinancialHistory.noticeOfDefaultForeClosure",
            description: "Notice of Default (NOD)",
            modelPath: "borrowerFinancialHistory.noticeOfDefaultForeClosure"
          }
        ],
        selectMultiple: false,
        options: []
      },
      {
        label: "Type",
        component_id: "NOD Type",
        id: "6e074f2c-d736-44b7-8dbe-f878769641a2",
        type: "enum",
        ui: { col_size: 3, widget: "dropdown" },
        visible: true,
        encompass_ids: [
          {
            id: "borrowerFinancialHistory.nodType",
            description: "NOD Type",
            modelPath: "borrowerFinancialHistory.nodType"
          }
        ],
        selectMultiple: false,
        options: []
      },
      {
        label: "Bankruptcy",
        component_id: "Bankruptcy",
        id: "f90b9127-984f-4979-b6a9-54850a50b1de",
        type: "enum",
        ui: { col_size: 3, widget: "dropdown" },
        visible: true,
        encompass_ids: [
          {
            id: "borrowerFinancialHistory.bankruptcyInMonths",
            description: "Bankruptcy",
            modelPath: "borrowerFinancialHistory.bankruptcyInMonths"
          }
        ],
        selectMultiple: false,
        options: [
          {
            id: "Never or none in the last 7 years",
            text: "Never or none in the last 7 years",
            value: null,
            visible: true
          },
          {
            id: "None in last 60 months",
            text: "None in last 60 months",
            value: 60,
            visible: true
          },
          {
            id: "None in last 48 months",
            text: "None in last 48 months",
            value: 48,
            visible: true
          },
          {
            id: "None in last 36 months",
            text: "None in last 36 months",
            value: 36,
            visible: true
          },
          {
            id: "None in last 24 months",
            text: "None in last 24 months",
            value: 24,
            visible: true
          },
          {
            id: "None in last 18 months",
            text: "None in last 18 months",
            value: 18,
            visible: true
          },
          {
            id: "None in last 12 months",
            text: "None in last 12 months",
            value: 12,
            visible: true
          },
          {
            id: "Currently in Bankruptcy",
            text: "Currently in Bankruptcy",
            value: 0,
            visible: true
          },
          {
            id: "None in last 6 months",
            text: "None in last 6 months",
            value: 6,
            visible: true
          },
          {
            id: "Within last 6 months",
            text: "Within last 6 months",
            value: 1,
            visible: true
          }
        ]
      },
      {
        label: "Type",
        component_id: "Bankruptcy Type",
        id: "84f18a33-4f00-4e89-86d8-f5f8073fd0f1",
        type: "enum",
        ui: { col_size: 3, widget: "dropdown" },
        visible: true,
        encompass_ids: [
          {
            id: "borrowerFinancialHistory.bkType",
            description: "Bankruptcy Type",
            modelPath: "borrowerFinancialHistory.bkType"
          }
        ],
        options: [],
        selectMultiple: false
      }
    ]
  },
  {
    label: "Supplemental Funding",
    component_id: "Supplemental Funding",
    id: "754d6679-bdd8-4e76-a912-01469629bfee",
    type: "field_group",
    visible: false,
    visible_check: {
      handler: "835dd9a9-6ed0-4614-9e3b-3fc3e967eddd"
    },
    ui: {},
    fields: [
      {
        label: "Gift Funds $",
        component_id: "Gift Funds $",
        id: "527db63c-03af-41ca-b22e-49271978324d",
        type: "number",
        visible: true,
        ui: { col_size: 3, widget: "currency" },
        encompass_ids: [
          {
            id: "borrowers[0].giftFundsDollar",
            description: "Gift Funds $",
            modelPath: "borrowers[0].giftFundsDollar"
          }
        ]
      },
      {
        label: "Gift Funds %",
        component_id: "Gift Funds %",
        id: "fe086ca9-9436-446f-b14c-b674ca7add32",
        type: "number",
        visible: true,
        ui: { col_size: 3, widget: "percent" },
        encompass_ids: [
          {
            id: "borrowers[0].giftFundsPercent",
            description: "Gift Funds %",
            modelPath: "borrowers[0].giftFundsPercent"
          }
        ]
      },
      {
        label: "Seller Concessions $",
        component_id: "Seller Concessions $",
        id: "9c6d72a7-eaf8-49c6-b567-5ddc642f8543",
        type: "number",
        visible: true,
        ui: { col_size: 3, widget: "currency" },
        encompass_ids: [
          {
            id: "borrowers[0].sellerDollar",
            description: "Seller Concessions $",
            modelPath: "borrowers[0].sellerDollar"
          }
        ]
      },
      {
        label: "Seller Concessions %",
        component_id: "Seller Concessions %",
        id: "860c9dac-0b0b-426f-a93d-ef26e7f7e9c8",
        type: "number",
        visible: true,
        ui: { col_size: 3, widget: "percent" },
        encompass_ids: [
          {
            id: "borrowers[0].sellerPercent",
            description: "Seller Concessions %",
            modelPath: "borrowers[0].sellerPercent"
          }
        ]
      }
    ]
  }
];
const SubjectPropertyVisibleFields = [
  {
    label: "Property Type",
    component_id: "Property Type",
    ui: {
      col_size: 4,
      widget: "dropdown"
    },
    selectMultiple: false,
    visible: true,
    required: true,
    id: "cc00d48d-34a9-4ea0-9b5b-34fabce99b8c",
    type: "enum",
    encompass_ids: [
      {
        id: "property.type",
        description: "Property Type",
        modelPath: "property.type"
      }
    ],
    options: []
  },
  {
    label: "Occupancy Type",
    component_id: "Occupancy Type",
    ui: {
      col_size: 4,
      widget: "dropdown"
    },
    selectMultiple: false,
    required: true,
    visible: true,
    id: "df69c396-fa9d-43b7-9a09-34ff6b54e465",
    type: "enum",
    encompass_ids: [
      {
        id: "property.use",
        description: "Occupancy Type",
        modelPath: "property.use"
      }
    ],
    options: []
  },
  {
    label: "Rural/Unique",
    component_id: "Rural/Unique",
    id: "152a038f-55c3-4f41-ad93-378b430c43d4",
    type: "boolean",
    ui: {
      widget: "checkbox"
    },
    visible: true,
    encompass_ids: [
      {
        id: "property.rural",
        description: "Rural/Unique",
        modelPath: "property.rural"
      }
    ]
  },
  {
    label: "Condotel",
    component_id: "Condotel",
    id: "aa2f33c3-af99-4fa8-9f8b-c73bfe672c72",
    type: "boolean",
    ui: {
      widget: "checkbox"
    },
    visible: false,
    visible_check: {
      handler: "b8810378-bc88-4644-8a8a-d858d5703c68"
    },
    encompass_ids: [
      {
        id: "loanInformation.condotel",
        description: "Property Info Is Condotel",
        modelPath: "loanInformation.condotel"
      }
    ]
  },
  {
    label: "Non-Warrantable Condo",
    component_id: "Non-Warrantable Condo",
    id: "43d8b8df-3ba7-425b-84ed-f80a2308efca",
    type: "boolean",
    ui: {
      widget: "checkbox"
    },
    visible: false,
    visible_check: {
      handler: "b8810378-bc88-4644-8a8a-d858d5703c68"
    },
    encompass_ids: [
      {
        id: "loanInformation.non_warrantable_Condo",
        description: "Property Info Is Non-Warrantable Project",
        modelPath: "loanInformation.non_warrantable_Condo"
      }
    ]
  },
  {
    label: "Address",
    component_id: "Address",
    id: "bca947c4-0f5d-426d-82fc-03e3d4d58b83",
    type: "field_group",
    visible: true,
    ui: {},
    fields: [
      {
        label: "Street Address",
        component_id: "Street Address",
        id: "10d39fa8-307c-464f-96ed-b3fcad27404f",
        type: "string",
        visible: true,
        ui: { col_size: 5, widget: "text" },
        encompass_ids: [
          {
            id: "property.streetAddress",
            description: "Street Address",
            modelPath: "property.streetAddress"
          }
        ]
      },
      {
        label: "Unit Type",
        component_id: "Unit Type",
        id: "986a708b-06a7-4a58-ac71-0a0c7fe39ac9",
        type: "enum",
        visible: true,
        ui: { col_size: 5, widget: "dropdown" },
        encompass_ids: [
          {
            id: "property.unitTypeId",
            description: "Unit Type",
            modelPath: "property.unitTypeId"
          }
        ],
        options: []
      },
      {
        label: "Unit Number",
        component_id: "Unit Number",
        id: "c8fb9f99-6737-4080-9be7-9abc146437cf",
        type: "number",
        visible: true,
        ui: { col_size: 5 },
        encompass_ids: [
          {
            id: "property.unitNumber",
            description: "Unit Number",
            modelPath: "property.unitNumber"
          }
        ]
      },
      {
        label: "Zip Code",
        component_id: "Zip Code",
        id: "ea47c3a2-80ab-402a-866b-0b94d39137ec",
        type: "string",
        visible: true,
        ui: { col_size: 5, widget: "text" },
        encompass_ids: [
          {
            id: "property.zip",
            description: "Zip Code",
            modelPath: "property.zip"
          }
        ]
      },
      {
        label: "State",
        component_id: "State",
        id: "2104c208-a90d-4206-8191-6fd503e750f1",
        type: "enum",
        ui: { col_size: 5, widget: "dropdown" },
        required: true,
        visible: true,
        encompass_ids: [
          {
            id: "property.state",
            description: "State",
            modelPath: "property.state"
          }
        ],
        options: []
      },
      {
        label: "City",
        component_id: "City",
        id: "46791b50-5339-46e4-ac50-a1753ec6820b",
        type: "string",
        visible: true,
        ui: { col_size: 5, widget: "text" },
        encompass_ids: [
          {
            id: "property.city",
            description: "City",
            modelPath: "property.city"
          }
        ]
      },
      {
        label: "County",
        component_id: "County",
        id: "f52cdcdc-9ba9-4369-84db-b3591c573cc1",
        type: "enum",
        visible: true,
        ui: { col_size: 5, widget: "dropdown" },
        encompass_ids: [
          {
            id: "property.county",
            description: "County",
            modelPath: "property.county"
          }
        ],
        options: [
          {
            id: "d62d1ad1-6f66-4b80-94c6-d85946256dc7",
            text: "No values yet",
            value: "No values yet",
            visible: true
          }
        ]
      }
    ]
  }
];
const SubjectPropertyDetailedFields = [
  {
    label: "Annual Property Taxes",
    component_id: "Annual Property Taxes",
    id: "7e8175d9-a843-448a-9359-8e5ecb0f85ac",
    required: true,
    type: "number",
    ui: {
      col_size: 3,
      widget: "currency"
    },
    visible: true,
    visible_check: {
      handler: "305c1831-0004-4a2e-8cdb-6bf85c1a0029"
    },
    encompass_ids: [
      {
        id: "property.tax",
        description: "Annual Property Taxes",
        modelPath: "property.tax"
      }
    ]
  },
  {
    label: "Annual Homeowners Insurance",
    component_id: "Annual Homeowners Insurance",
    id: "c9c9df86-96c2-473d-a1f7-4824fa6098c8",
    required: true,
    type: "number",
    ui: {
      col_size: 3,
      widget: "currency"
    },
    visible: true,
    visible_check: {
      handler: "305c1831-0004-4a2e-8cdb-6bf85c1a0029"
    },
    encompass_ids: [
      {
        id: "property.insuranceAmount",
        description: "Annual Homeowners Insurance",
        modelPath: "property.insuranceAmount"
      }
    ]
  },
  {
    label: "Monthly Association Fees",
    component_id: "Monthly Association Fees",
    id: "c6ea1e71-e879-4be5-a12d-1b4c3f175798",
    required: true,
    type: "number",
    ui: {
      col_size: 3,
      widget: "currency"
    },
    visible: true,
    visible_check: {
      handler: "305c1831-0004-4a2e-8cdb-6bf85c1a0029"
    },
    encompass_ids: [
      {
        id: "property.associationFee",
        description: "Monthly Association Fees",
        modelPath: "property.associationFee"
      }
    ]
  },
  {
    label: "Monthly Rental Income",
    component_id: "Monthly Rental Income",
    id: "e6bc2824-3ff5-4c20-a4a4-eeb514e0e3cf",
    required: true,
    type: "number",
    ui: {
      col_size: 3,
      widget: "currency"
    },
    visible: true,
    visible_check: {
      handler: "305c1831-0004-4a2e-8cdb-6bf85c1a0029"
    },
    encompass_ids: [
      {
        id: "property.rentalIncome",
        description: "Monthly Rental Income",
        modelPath: "property.rentalIncome"
      }
    ]
  },
  {
    label: "Geocodes",
    component_id: "Geocodes",
    type: "field_group",
    visible: true,
    id: "8316395d-d7ac-4a81-96d1-0e7bb2dc31e0",
    fields: [
      {
        label: "MSA",
        component_id: "MSA",
        id: "778465bb-dd30-4076-8e7e-747cd51fd45d",
        type: "null",
        ui: {
          col_size: 3,
          widget: "label"
        },
        visible: true,
        encompass_ids: [
          {
            id: "property.msa",
            description: "MSA",
            modelPath: "property.msa"
          }
        ]
      },
      {
        label: "Census Tract",
        component_id: "Census Tract",
        id: "c1fc142c-f404-41de-9867-effd64eea96f",
        type: "null",
        ui: {
          col_size: 3,
          widget: "label"
        },
        visible: true,
        encompass_ids: [
          {
            id: "property.censusTract",
            description: "Census Tract",
            modelPath: "property.censusTract"
          }
        ]
      },
      {
        label: "County Code",
        component_id: "County Code",
        id: "d717f7f4-7231-4c1c-bcdf-5c2577c4fdf0",
        type: "null",
        ui: {
          col_size: 3,
          widget: "label"
        },
        visible: true,
        encompass_ids: [
          {
            id: "property.countyCode",
            description: "County Code",
            modelPath: "property.countyCode"
          }
        ]
      },
      {
        label: "State Code",
        component_id: "State Code",
        id: "a087376f-dfc2-4989-9c74-911c685c045f",
        type: "null",
        ui: {
          col_size: 3,
          widget: "label"
        },
        visible: true,
        encompass_ids: [
          {
            id: "property.stateCode",
            description: "State Code",
            modelPath: "property.stateCode"
          }
        ]
      }
    ]
  },
  {
    label: "Other Real Estate Owned",
    component_id: "Other Real Estate Owned",
    id: "7da8a038-9556-4ad5-ab1c-9edb79f29c8c",
    type: "field_group",
    visible: true,
    fields: [
      {
        label: "Occupancy Type",
        component_id: "Occupancy Type",
        id: "3d629597-befe-4799-a461-64ede0213038",
        type: "enum",
        visible: true,
        required: true,
        ui: {
          col_size: 6,
          widget: "dropdown"
        },
        encompass_ids: [
          {
            id: "property.otherRealEstateOwned.use",
            description: "Occupancy Type",
            modelPath: "property.otherRealEstateOwned[0].use"
          }
        ],
        options: [
          {
            id: "45c784e5-b3ee-41df-a141-bb3c2878142a",
            text: "Pending Sale/Sold",
            value: "4",
            visible: true
          },
          {
            id: "0b449815-d318-4496-bea2-6322b049f2a1",
            text: "Primary Residence",
            value: "1",
            visible: true
          },
          {
            id: "549999cd-2443-4a6d-824c-c71f0654f021",
            text: "Secondary Residence",
            value: "2",
            visible: true
          },
          {
            id: "0e2ec437-3342-40b6-8f1d-eda0e4d84baa",
            text: "Investment/Rental",
            value: "3",
            visible: true
          },
          {
            id: "0d74c2f1-3be8-44bd-a41a-ca9d35c5b349",
            text: "Other",
            value: "5",
            visible: true
          }
        ]
      },
      {
        label: "Market Value",
        component_id: "Market Value",
        id: "b8194e93-9fda-44b1-a41e-f01561c6b5c7",
        type: "number",
        visible: true,
        required: true,
        ui: {
          col_size: 6,
          widget: "currency"
        },
        encompass_ids: [
          {
            id: "property.otherRealEstateOwned.value",
            description: "Market Value",
            modelPath: "property.otherRealEstateOwned[0].value"
          }
        ]
      },
      {
        label: "Mortgage Balance",
        component_id: "Mortgage Balance",
        id: "ada3d700-2c07-45d1-a631-7be03778c93c",
        type: "number",
        visible: true,
        required: true,
        ui: {
          col_size: 6,
          widget: "currency"
        },
        encompass_ids: [
          {
            id: "property.otherRealEstateOwned.mtgBalance",
            description: "Mortgage Balance",
            modelPath: "property.otherRealEstateOwned[0].mtgBalance"
          }
        ]
      },
      {
        label: "Mortgage Payment",
        component_id: "Mortgage Payment",
        id: "f4bcc965-e97f-4c0a-8a40-7cf8df299834",
        type: "number",
        visible: true,
        required: true,
        ui: {
          col_size: 6,
          widget: "currency"
        },
        encompass_ids: [
          {
            id: "property.otherRealEstateOwned.monthlyPayment",
            description: "Mortgage Payment",
            modelPath: "property.otherRealEstateOwned[0].monthlyPayment"
          }
        ]
      },
      {
        label: "Rental Income",
        component_id: "Rental Income",
        id: "809267ef-399a-409e-8925-e1e3b6e5351c",
        type: "number",
        visible: true,
        ui: {
          col_size: 6,
          widget: "currency"
        },
        encompass_ids: [
          {
            id: "property.otherRealEstateOwned.rentalIncome",
            description: "Rental Income",
            modelPath: "property.otherRealEstateOwned[0].rentalIncome"
          }
        ]
      }
    ],
    ui: {}
  }
];
const getAllDraggableFields = () => [].concat(
  GeneralLoanInfoVisibleFields,
  GeneralLoanInfoDetailedFields,
  ProductInfoVisibleFields,
  ProductInfoDetailedFields,
  FinanceInfoVisibleFields,
  FinanceInfoDetailedFields,
  SubjectPropertyVisibleFields,
  SubjectPropertyDetailedFields
).map((field) => ({ schema: field }));
const getDraggableFieldList = (clientLookups) => {
  return getAllDraggableFields().map((field) => {
    if (field.schema.type === "enum") {
      processFieldOptionsFromLookups(field.schema, clientLookups);
    }
    return field;
  });
};
export {
  FinanceInfoDetailedFields,
  FinanceInfoVisibleFields,
  GeneralLoanInfoDetailedFields,
  GeneralLoanInfoVisibleFields,
  ProductInfoDetailedFields,
  ProductInfoVisibleFields,
  SubjectPropertyDetailedFields,
  SubjectPropertyVisibleFields,
  getAllDraggableFields,
  getDraggableFieldList
};
